import { BasePage } from '@/components/ui/base-page'

export function WealthPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add WealthPage specific content here */}
    </BasePage>
  )
}